import {useGetAndSet} from "./useGetAndSet";
import {createSetVehicleModelDataAction} from "../actions/dataActions";


export const useVehicleModelData = (params, dataFresh) => {
    return useGetAndSet("vehiclemodel", params, createSetVehicleModelDataAction, dataFresh)
}